export const trackEvent = (onTrack, event) => {
  void onTrack(event.key, event.properties);
};